import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/promocionPuesto';
import Promocion from './PromocionPuesto';


const ms2p = (state) => {
  return {
    ...state.promocion_puesto_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Promocion);